function customMarker(latLng, title, permalink, delay, map) {
  this.latLng = latLng;
  this.title = title;
  this.permalink = permalink;
  this.delay = delay;
  this.setMap(map);
}

$(document).ready(function() {

  /*** trigger mobile nav ***/
  $('#mobile-menu-trigger').click(function() {
    $('body').toggleClass('mobile-menu-active');
  });

  /*** smooth scroll to anchors ***/
  $('a[href*="#"]').not('[href="#"]').click(function(e) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    }
  });

  /*** custom map markers ***/
  customMarker.prototype = new google.maps.OverlayView();

  customMarker.prototype.draw = function () {
    var thisMarker = this;
    var div = this.div;
    if (!div) {
      div = this.div = document.createElement('div');
      div.className = 'map-marker';
      div.setAttribute('data-title', this.title);
      // div.setAttribute('data-permalink', this.permalink);
      div.style.animationDelay = this.delay + 's';
      // div.setAttribute('style', 'animation-delay: ' + this.delay + 's;')
      // div.textContent = this.title;

      // google.maps.event.addDomListener(div, 'click', function (event) {
      //   var permalink = $(this).attr('data-permalink');
      //   console.log('permalink:', permalink);
      //   if (permalink) {
      //     window.location.href = permalink;  
      //   }
      // });

      var panes = this.getPanes();
      panes.floatPane.appendChild(div);
    }

    var position = this.getProjection().fromLatLngToDivPixel(this.latLng);
    if (position) {
      div.style.left = position.x + 'px';
      div.style.top = position.y + 'px';
    }
  };

  customMarker.prototype.remove = function () {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  customMarker.prototype.getPosition = function () {
    return this.latLng;
  };

  /*** markets map ***/
  if ($('#markets-map').length && $('#markets-map').attr('data-markets')) {

    // get market data from template
    var markets = JSON.parse($('#markets-map').attr('data-markets'));

    var bounds = new google.maps.LatLngBounds();

    var mapOptions = {
      mapTypeId: 'terrain',
      // disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling: 'none',
      styles: [
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "all",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": 0
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#ffffff"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "all",
          "stylers": [
            {
              "hue": "#ffffff"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 100
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#ffffff"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 100
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": 0
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#bbbbbb"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 26
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#dddddd"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -3
            },
            {
              "visibility": "on"
            }
          ]
        }
      ]
    };

    // create map
    var map = new google.maps.Map(document.getElementById('markets-map'), mapOptions);

    // set transition delay for first marker
    var delay = 0;

    // loop through markets to apply customMarker
    markets.forEach(function(market) {
      var latLng = new google.maps.LatLng(market.lat, market.lng);
      var marketMarker = new customMarker(latLng, market.title, market.permalink, delay, map);
      bounds.extend(latLng);
      delay = parseFloat(delay += 0.025);
    });

    // fit all markers on the map
    map.fitBounds(bounds);

    // trigger animations when scrolled into view

    var config = {
      threshold: [0.9]
    }

    var marketsMap = document.querySelector('#markets-map');

    var mapObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.9) {
          entry.target.classList.add('map-active');
          mapObserver.unobserve(entry.target);
        }
      });
    }, config);

    mapObserver.observe(marketsMap);

  }

  /*** office map ***/
  if ($('#office-map').length && $('#office-map').attr('data-latitude') && $('#office-map').attr('data-longitude')) {

    var lat = Number($('#office-map').attr('data-latitude'));
    var lng = Number($('#office-map').attr('data-longitude'));

    var latLng = new google.maps.LatLng(lat, lng);

    var mapOptions = {
      mapTypeId: 'terrain',
      // disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling: 'none',
      zoom: 14,
      center: latLng,
      styles: [
        {
          "featureType": "administrative",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#dddddd"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -3
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#bbbbbb"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 26
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "color": "#999999"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "stylers": [
            {
              "hue": "#ffffff"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 100
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#ffffff"
            },
            {
              "saturation": -100
            },
            {
              "lightness": 100
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
            {
              "hue": "#000000"
            },
            {
              "saturation": -100
            },
            {
              "lightness": -100
            },
            {
              "visibility": "off"
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map(document.getElementById('office-map'), mapOptions);

    var marker = new customMarker(latLng, 'Parking Advisors, Inc.', 0, map);

    var officeMap = document.querySelector('#office-map');

    var mapObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.9) {
          entry.target.classList.add('map-active');
          mapObserver.unobserve(entry.target);
        }
      });
    }, config);

    mapObserver.observe(officeMap)

  }

  /*** home header ***/

//   if ($('.section-hero-home-title').length) {
//
//     var config = { threshold: [0.1] };
//     var headline = document.querySelector('.section-hero-home-title');
//
//     var observer = new IntersectionObserver(entries => {
//       entries.forEach(entry => {
//         if (entry.intersectionRatio > 0.1) {
//           entry.target.classList.add('section-hero-home-title-active');
//           observer.unobserve(entry.target);
//         }
//       });
//     }, config);
//
//     observer.observe(headline);
//
//   }

  /*** boxes ***/

  if ($('.box').length) {

    var config = { threshold: [0.15] };

    var boxes = document.querySelectorAll('.box');
    var boxObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.15) {
          entry.target.classList.add('box-active');
          boxObserver.unobserve(entry.target);
        }
      });
    }, config);

    boxes.forEach(box => {
      boxObserver.observe(box);
    });

  }

  /*** slanted sections ***/

  if ($('.section-slanted').length) {

    var config = { threshold: [0.15] };

    var texts = document.querySelectorAll('.section-slanted-content');
    var textObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.15) {
          entry.target.classList.add('section-slanted-content-active');
          textObserver.unobserve(entry.target);
        }
      });
    }, config);

    texts.forEach(text => {
      textObserver.observe(text);
    });

    var images = document.querySelectorAll('.section-slanted-image');
    var imageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.15) {
          entry.target.classList.add('section-slanted-image-active');
          imageObserver.unobserve(entry.target);
        }
      });
    }, config);

    images.forEach(image => {
      imageObserver.observe(image);
    });

  }

  /*** white label screenshots ***/

  if ($('.white-label-site-image').length) {

    var config = { threshold: [0.9] };
    var screenshots = document.querySelectorAll('.white-label-site-image');

    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.9) {
          entry.target.classList.add('white-label-site-image-active');
          observer.unobserve(entry.target);
        }
      });
    }, config);

    screenshots.forEach(screenshot => {
      observer.observe(screenshot);
    });

  }

  /*** open overlay ***/
  $('.team-member').click(function() {

    var thisTeamMember = $(this);

    var teamMemberId = $(thisTeamMember).attr('data-id');

    $(thisTeamMember).addClass('team-member-active');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'team_member_modal',
        teamMemberId: teamMemberId
      },
      success: function(results) {

        var results = $.parseJSON(results);
        console.log(results);

        if (results.status == 'success') {

          $('.team-member-overlay-name').empty().text(results['name']);
          $('.team-member-overlay-job-title').empty().text(results['job_title']);
          $('.team-member-overlay-content').empty().html(results['biography']);
          $('.team-member-overlay-image img').removeAttr('src');
          $('.team-member-overlay-image img').removeAttr('srcset');
          $('.team-member-overlay-image img').removeAttr('alt');

          if (results['image']) {
            $('.team-member-overlay-image img').attr('src', results['image']['sizes']['team-member-photo-1x']);
            $('.team-member-overlay-image img').attr('srcset', results['image']['sizes']['team-member-photo-1x'] + ', ' + results['image']['sizes']['team-member-photo-2x'] + ' 2x');
            $('.team-member-overlay-image img').attr('alt', 'Photo of ' + results['name']);
          }

          $('body').toggleClass('overlay-active');

          $(document).on('keydown', function(e) {
            if (e.keyCode == 27) {
              $('body').removeClass('overlay-active');
              $(document).off('keydown');
            }
          });

          $(thisTeamMember).removeClass('team-member-active');

        } else {

          alert('Something went wrong?');

          $(thisTeamMember).removeClass('team-member-active');

        }

      },
      error: function(results) {

        var results = $.parseJSON(results);
        console.log('error!', results);

        $(thisTeamMember).removeClass('team-member-active');

        alert('Something went wrong?');

      }
    });

  });

  /*** close overlay ***/
  $('#overlay-close').click(function() {
    $('body').removeClass('overlay-active');
    $(document).off('keydown');
  });

  /*** statistics count up from zero ***/
  if ($('.statistic-number-target').length) {

    const config = { threshold: [0.9] };
    const statistics = document.querySelectorAll('.statistic-number-target');

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.9) {

          var $entry = $(entry.target);
          var thisId = $entry.attr('id');
          var countFrom = $entry.text();
          var countTo = $entry.attr('data-number');

          if (countTo == Math.floor(countTo)) {
            var decimalPlaces = 0;
          } else {
            var pieces = countTo.split('.');
            decimalPlaces = pieces[1].length;
          }

          var options = {
            startVal: countFrom,
            decimalPlaces: decimalPlaces,
            duration: 3
          }

          var counter = new CountUp(thisId, countTo, options);
          if (!counter.error) {
            counter.start();
          } else {
            console.log('error!', counter.error);
          }

        }
      });
    }, config);

    statistics.forEach(statistic => {
      observer.observe(statistic);
    });

  }

  // trigger resources layout animations
  if ($('body').hasClass('page-template-page-services-subpage') || $('body').hasClass('page-template-page-work') || $('body').hasClass('archive-case-studies')) {

    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('section-resources-header')) {
            entry.target.classList.add('section-resources-header-active');
          } else if (entry.target.classList.contains('resource')) {
            entry.target.classList.add('resource-active');
          }
        }
      });
    }, { threshold: [ 0.5 ] });

    var resourcesHeader = document.querySelector('.section-resources-header');
    var resources = document.querySelectorAll('.resource');

    if (resourcesHeader) {
      observer.observe(resourcesHeader);
    }

    if (resources) {
      resources.forEach(resource => {
        observer.observe(resource);
      });
    }

  }

  /*** projects masonry grid layout ***/
  if ($('.projects-masonry-grid').length) {

    var projectsGrid = $('.projects-masonry-grid').isotope({
      itemSelector: '.project-card',
      percentPosition: true,
      masonry: {
        columnWidth: '.project-card',
        gutter: 16
      }
    });

    projectsGrid.imagesLoaded().progress(function() {
      projectsGrid.isotope('layout');
    });

    $('.project-filters-group').on('click', 'button', function() {
      $(this).siblings().removeClass('project-filter-active');
      $(this).addClass('project-filter-active');
      var filterValue = $(this).attr('data-filter');
      projectsGrid.isotope({ filter: filterValue });
    });

  }

  /*** resources ***/
  if ($('body').hasClass('page-template-page-resources')) {

    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log(entry);
          if (entry.target.classList.contains('section-resources-header')) {
            entry.target.classList.add('section-resources-header-active');
          } else if (entry.target.classList.contains('resource')) {
            entry.target.classList.add('resource-active');
          } else if (entry.target.classList.contains('section-market-research')) {
            entry.target.classList.add('section-market-research-active');
          } else if (entry.target.classList.contains('section-market-research-header')) {
            entry.target.classList.add('section-market-research-header-active');
          } else if (entry.target.classList.contains('featured-city')) {
            entry.target.classList.add('featured-city-active');
          } else if (entry.target.classList.contains('other-city')) {
            entry.target.classList.add('other-city-active');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: [ 0.5 ] });

    // get elements to observe
    // var resourcesHeader = document.querySelector('.section-resources-header');
    // var resources = document.querySelectorAll('.resource');
    var researchSection = document.querySelector('.section-market-research');
    var researchHeader = document.querySelector('.section-market-research-header');
    var featuredCities = document.querySelectorAll('.featured-city');
    var otherCities = document.querySelectorAll('.other-city');
    
    console.log('featuredCities:', featuredCities);
    console.log('otherCities:', otherCities);

    // observe those elements!
    // observer.observe(resourcesHeader);
    // resources.forEach(resource => {
    //   observer.observe(resource);
    // });
    observer.observe(researchSection);
    observer.observe(researchHeader);
    featuredCities.forEach(city => {
      observer.observe(city);
    });
    otherCities.forEach(city => {
      observer.observe(city);
    });

  }

  /*** newsletter form submission ***/
  $('#newsletter-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function(error, element) {
      error.appendTo(element.parent('.form-field'));
    },
    highlight: function(element, errorClass, validClass) {
      $(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function(element, errorClass, validClass) {
      $(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'newsletter-email': {
        required: true,
        email: true
      }
    },
    messages: {
      'newsletter-email': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      }
    },
    submitHandler: function(form) {

      /* disable form elements and submit button */
      $('input[type="email"]').prop('disabled', true);
      $('.button-spinner', form).prop('disabled', true);

      /* get data from form */
      var name = $('#newsletter-name').val();
      var email = $('#newsletter-email').val();
      var nonce = $('#newsletter-form-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'newsletter_form',
          name: name,
          email: email,
          nonce: nonce
        },
        success: function(results) {
          var results = $.parseJSON(results);
          console.log(results);
          // inject success or error message
          $('input[type="email"]', form).empty().attr('placeholder', results.message);
          // re-enable form elements and submit button
          $('input[type="text"], input[type="email"], textarea').prop('disabled', false);
          $('.button-spinner', form).prop('disabled', false);
        },
        error: function(results) {
          var results = $.parseJSON(results);
          console.log(results);
          // inject error message
          $('.form-submit-message', form).empty().removeClass('form-submit-message-success').addClass('form-submit-message-error').text(results.message);
          // re-enable form elements and submit button
          $('input[type="text"], input[type="email"], textarea').prop('disabled', false);
          $('.button-spinner', form).prop('disabled', false);
        }
      });

    }
  });

});
